import CustomColumn from './src/custom-column.vue'
import { withInstall } from '@el-plus/utils/with-install'

export const EpCustomColumn = withInstall(CustomColumn)
export default EpCustomColumn
export type CustomColumnInstance = InstanceType<typeof EpCustomColumn>
export * from './src/custom-column'
